<template>
	<div class="animated fadeIn">
		<b-card>
			<b-row>
				<b-col sm="12">
                    <b-row>
                        <h5 class="col-md-12 card-title">Laporan Rekapitulasi Data Sampah/Limbah B3 Dari Satpel Kecamatan</h5>
                    </b-row>
					<form class="form-horizontal" @submit.prevent="downloadReport('laporan-1')">
						<b-row>
							<b-form-group class="col-md-2" label="Tanggal Awal">
								<b-form-input type="date" required v-model="report1.StartDate">
								</b-form-input>
							</b-form-group>
							<b-form-group class="col-md-2" label="Tanggal Akhir">
								<b-form-input type="date" required v-model="report1.EndDate">
								</b-form-input>
							</b-form-group>
							<b-form-group class="col-md-3" label="Kota">
								<select v-model="report1.KodeKota" required class="form-control">
									<option value="">Pilih Kota</option>
									<option v-for="(v,i) in masters.cities" :value="v.kodeKota" :key="i">
										{{v.namaKota}}
									</option>
								</select>
							</b-form-group>
							<b-form-group class="col-md-2" label="Tahun">
								<b-form-input type="number" required v-model="report1.Tahun">
								</b-form-input>
							</b-form-group>
							<b-col md="3">
								<b-button type="submit" variant="primary" style="margin-top: 1.8rem;">
									Download
								</b-button>
							</b-col>
						</b-row>
					</form>
				</b-col>
			</b-row>
		</b-card>

        <b-card>
			<b-row>
				<b-col sm="12">
                    <b-row>
                        <h5 class="col-md-12 card-title">Laporan Rekapitulasi Data Kelurahan yang Terlayani Pengelolaan Limbah B3 Rumah Tangga dari 5 Wilayah Kota Adm.
                            Jakarta dan 1 Wilayah Kabupaten Kepulauan Seribu di Provlnsl DKJ</h5>
                    </b-row>
					<form class="form-horizontal" @submit.prevent="downloadReport('laporan-2')">
						<b-row>
							<b-form-group class="col-md-3" label="Tanggal Awal">
								<b-form-input type="date" required v-model="report2.StartDate">
								</b-form-input>
							</b-form-group>
							<b-form-group class="col-md-3" label="Tanggal Akhir">
								<b-form-input type="date" required v-model="report2.EndDate">
								</b-form-input>
							</b-form-group>
							<b-col md="3">
								<b-button type="submit" variant="primary" style="margin-top: 1.8rem;">
									Download
								</b-button>
							</b-col>
						</b-row>
					</form>
				</b-col>
			</b-row>
		</b-card>

        <b-card>
			<b-row>
				<b-col sm="12">
                    <b-row>
                        <h5 class="col-md-12 card-title">Laporan Penjemputan e-Waste 5 (lima) Suku Dinas Lingkungan Hidup Kota Adm Jakarta dan 1 (satu) Suku Dinas
                            Lingkungan Hidup Kabupaten Administrasi Kepulauan Seribu</h5>
                    </b-row>
					<form class="form-horizontal" @submit.prevent="downloadReport('laporan-3')">
						<b-row>
							<b-form-group class="col-md-3" label="Tanggal Awal">
								<b-form-input type="date" required v-model="report3.StartDate">
								</b-form-input>
							</b-form-group>
							<b-form-group class="col-md-3" label="Tanggal Akhir">
								<b-form-input type="date" required v-model="report3.EndDate">
								</b-form-input>
							</b-form-group>
							<b-col md="3">
								<b-button type="submit" variant="primary" style="margin-top: 1.8rem;">
									Download
								</b-button>
							</b-col>
						</b-row>
					</form>
				</b-col>
			</b-row>
		</b-card>

        <b-card>
			<b-row>
				<b-col sm="12">
                    <b-row>
                        <h5 class="col-md-12 card-title">Laporan Rincian Kegiatan Pengangkutan Sampah B3 (selain e-Waste) oleh Pihak Ketiga di masing-masing Wilayah Kota
                            Adm. Jakarta</h5>
                    </b-row>
					<form class="form-horizontal" @submit.prevent="downloadReport('laporan-4')">
						<b-row>
							<b-form-group class="col-md-3" label="Tanggal Awal">
								<b-form-input type="date" required v-model="report4.StartDate">
								</b-form-input>
							</b-form-group>
							<b-form-group class="col-md-3" label="Tanggal Akhir">
								<b-form-input type="date" required v-model="report4.EndDate">
								</b-form-input>
							</b-form-group>
							<b-col md="3">
								<b-button type="submit" variant="primary" style="margin-top: 1.8rem;">
									Download
								</b-button>
							</b-col>
						</b-row>
					</form>
				</b-col>
			</b-row>
		</b-card>

        <b-card>
			<b-row>
				<b-col sm="12">
                    <b-row>
                        <h5 class="col-md-12 card-title">Laporan Rekapitulasi Jumlah Limbah B3 yang Dikelola Sebagai Target Program Pengendalian Bahan Berbahaya dan
                            Beracun (B3) dan Limbah Bahan Berbahaya dan Beracun (Limbah B3) </h5>
                    </b-row>
					<form class="form-horizontal" @submit.prevent="downloadReport('laporan-5')">
						<b-row>
							<b-form-group class="col-md-3" label="Tanggal Awal">
								<b-form-input type="date" required v-model="report5.StartDate">
								</b-form-input>
							</b-form-group>
							<b-form-group class="col-md-3" label="Tanggal Akhir">
								<b-form-input type="date" required v-model="report5.EndDate">
								</b-form-input>
							</b-form-group>
							<b-form-group class="col-md-1" label="TW">
								<b-form-input type="number" required v-model="report5.Tw">
								</b-form-input>
							</b-form-group>

							<b-form-group class="col-md-2" label="Tahun">
								<b-form-input type="number" required v-model="report5.Tahun">
								</b-form-input>
							</b-form-group>
							<b-col md="3">
								<b-button type="submit" variant="primary" style="margin-top: 1.8rem;">
									Download
								</b-button>
							</b-col>
						</b-row>
					</form>
				</b-col>
			</b-row>
		</b-card>
	</div>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';
	export default {
		name: 'ListReport',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				api_url: process.env.VUE_APP_API,
				report1: {
                    StartDate: "",
                    EndDate: "",
					KodeKota: "",
					Tahun: ""
                },
                report2: {
                    StartDate: "",
                    EndDate: ""
                },
                report3: {
                    StartDate: "",
                    EndDate: ""
                },
                report4: {
                    StartDate: "",
                    EndDate: ""
                },
                report5: {
                    StartDate: "",
                    EndDate: "",
					Tw: "",
					Tahun: ""
                },
				masters: {
					cities: []
				}
			}
		},
		created(){
			this.getCities();
		},
		methods: {
			getCities() {
				const _ = this
				_.$axios.get('Kota')
				.then(res => {
					_.masters.cities = res.data.data;
				});
			},
			downloadReport(fileName) {
				const _ = this;
				switch(fileName){
					case "laporan-1":
						window.open(`${_.api_url}/Report/exportRekapitulasiDataSampahLimbahB3/?StartDate=${_.report1.StartDate}&EndDate=${_.report1.EndDate}&KodeKota=${_.report1.KodeKota}&Tahun=${_.report1.Tahun}`);
					break;
					case "laporan-2":
						window.open(`${_.api_url}/Report/exportRekapitulasiDataKelurahanTerlayaniPengelolaanLimbahB3/?StartDate=${_.report2.StartDate}&EndDate=${_.report2.EndDate}`);
					break;
					case "laporan-3":
						window.open(`${_.api_url}/Report/exportPengumpulanEwaste/?StartDate=${_.report3.StartDate}&EndDate=${_.report3.EndDate}`);
					break;
					case "laporan-4":
						window.open(`${_.api_url}/Report/exportRekapitulasiDataSampahRincianKegiatanPengangkutanSampah/?StartDate=${_.report4.StartDate}&EndDate=${_.report4.EndDate}`);
					break;
					case "laporan-5":
						window.open(`${_.api_url}/Report/exportRekapitulasiJumlahLimbahB3Dikelola/?StartDate=${_.report5.StartDate}&EndDate=${_.report5.EndDate}&Tw=${_.report5.Tw}&Tahun=${_.report5.Tahun}`);
					break;
				}
			},
		},
	}
</script>